import { fetchHandler } from 'app/util/fetchHandler';

export interface IPKCE {
    challenge: string,
    challengeMethod: string
}
export const getChallenge = () => {
    return fetchHandler('/challenge').then( (c: any) => {
        let res: IPKCE = {
            challenge: `${c['code_challenge']}`,
            challengeMethod: `${c['code_challenge_method']}`
        }
        return res;
    });
}
